/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcQuotemediaV1EodPriceTaskState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_QUOTEMEDIA_V1_EOD_PRICE_TASK_STATE_ENTITY_NAME = 'exc.quotemedia.v1.EodPriceTask';
export const excQuotemediaV1EodPriceTaskStateEntity = new schema.Entity<ExcQuotemediaV1EodPriceTaskState>(EXC_QUOTEMEDIA_V1_EOD_PRICE_TASK_STATE_ENTITY_NAME, {}, { idAttribute: 'taskId' });

